<template>
  <div :class="['rounded-b-lg px-4', theme.middleScreen.backgroundColor]">
    <div class="w-full mx-auto pb-16">
      <div
        :class="[
          'pr-4 pl-4 pt-1 pb-1 rounded ml-4 mr-4 mb-2 text-center flex justify-center items-center',
          theme.body.textColor,
        ]"
      >
        <svg
          class="mr-1"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#4A5568"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {{ lang["select_day"][language] }}
      </div>
      <div
        v-if="
          this.menu.enable_free_timeslots &&
          this.menu.timeslots_mode == 'individual'
        "
      >
        <div>
          <div
            v-for="timeSlot in $_.groupBy(timeSlots, 'date')"
            :key="timeSlot.date + timeSlot.start_time"
            @click="changeDate(timeSlot[0].date)"
          >
            <div
              :class="[
                'rounded-large w-full h-10 mt-2 rounded flex items-center justify-center text-center text-sm rounded-large shadow-lg transition duration-500  hover:shadow-xl',
                selectedDate == timeSlot[0].date
                  ? 'transition duration-500 ' +
                    theme.body.selectedBackgroundColor +
                    ' ' +
                    theme.body.selectedTextColor
                  : theme.body.backgroundColor + ' ' + theme.body.textColor,
              ]"
            >
              {{ timeSlot[0].date }}
            </div>
          </div>
        </div>
        <div v-show="selectedDate"
            :class="[
              'pr-4 pl-4 pt-1 pb-1 rounded ml-4 mr-4 mb-2 text-center flex justify-center items-center',
              theme.body.textColor,
            ]"
          >
            <svg
              class="mr-1"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="#4A5568"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div
              v-show="
                selectedDate != '' &&
                $_.size(
                  $_.filter(timeSlots, function (timeSlot) {
                    return timeSlot.date == selectedDate;
                  })
                ) > 0
              "
            >
              {{ lang["select_time_slot"][language] }}
            </div>
            <div
              v-show="
                selectedDate != '' &&
                $_.size(
                  $_.filter(timeSlots, function (timeSlot) {
                    return timeSlot.date == selectedDate;
                  })
                ) == 0
              "
            >
              {{ lang["no_time_slots"][language] }}
            </div>
          </div>
        <div v-show="selectedDate">
          <div
            v-for="timeSlot in $_.orderBy($_.filter(timeSlots, function (timeSlot) {
              return timeSlot.date == selectedDate;
            }))"
            :key="timeSlot.date + timeSlot.start_time"
            :class="[
              selectedTimeSlot == `${timeSlot.date} ${timeSlot.start_time}`
                ? 'shadow-lg transition duration-500  hover:shadow-xl '+theme.body.selectedBackgroundColor +
                  ' ' +
                  theme.body.selectedTextColor
                : theme.body.backgroundColor + ' ' + theme.body.textColor,
              'w-full h-10 mt-2 rounded flex items-center justify-center rounded-large shadow-lg transition duration-500  hover:shadow-xl',
            ]"
            @click="
              selectedTimeSlot = `${timeSlot.date} ${timeSlot.start_time}`
            "
          >
            {{ timeSlot.start_time.substring(0, 5) }}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="flex flex-wrap">
          <div
            v-for="(date, index) in $_.filter(
              fullDates,
              function (date, index) {
                return index < totalDaysVisible;
              }
            )"
            :key="index"
            class="w-1/2 flex flex-wrap"
            @click="changeDate(date.fullDate)"
          >
            <div
              :class="[
                'rounded-large shadow-lg transition duration-500  hover:shadow-xl',
                selectedDate == `${date.fullDate}`
                  ? 'transition duration-500 ' +
                    theme.body.selectedBackgroundColor +
                    ' ' +
                    theme.body.selectedTextColor
                  : theme.body.backgroundColor + ' ' + theme.body.textColor,
                index % 2 == 0 ? 'mr-1' : 'ml-1',
                $_.size(
                  $_.filter(timeSlots, function (timeSlot) {
                    return timeSlot.date == date.fullDate;
                  })
                ) > 0
                  ? ''
                  : 'bg-gray-600 py-2 px-4 rounded opacity-50 cursor-not-allowed',
                'w-full h-10 mt-2 rounded flex items-center justify-center text-center text-sm rounded-large',
              ]"
            >
              {{ date.dayInText }} <br />
              {{ date.date }}
            </div>
          </div>
          <div class="w-1/2 flex flex-wrap" v-if="menu.max_timesl_days > 3">
            <div
              v-if="loadMoreDaysVisible "
              class="ml-1 w-full h-10 mt-2 flex items-center justify-center bg-gray-300 text-sm rounded-large"
              @click="showAllDates"
            >
              {{ lang["meer_dagen"][language] }}
            </div>

            <div
              v-else
              class="w-full h-10 ml-1 mt-2 rounded flex items-center justify-center bg-gray-300 text-sm rounded-large"
              @click="showLessDates"
            >
              {{ lang["minder_dagen"][language] }}
            </div>
          </div>
        </div>

        <SkeletonLoader v-if="loading" type="timeslot" :count="10" />

        <div v-else v-show="selectedDate != ''">
          <div
            :class="[
              'pr-4 pl-4 pt-1 pb-1 rounded ml-4 mr-4 mb-2 text-center flex justify-center items-center',
              theme.body.textColor,
            ]"
          >
            <svg
              class="mr-1"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="#4A5568"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div
              v-show="
                selectedDate != '' &&
                $_.size(
                  $_.filter(timeSlots, function (timeSlot) {
                    return timeSlot.date == selectedDate;
                  })
                ) > 0
              "
            >
              {{ lang["select_time_slot"][language] }}
            </div>
            <div
              v-show="
                selectedDate != '' &&
                $_.size(
                  $_.filter(timeSlots, function (timeSlot) {
                    return timeSlot.date == selectedDate;
                  })
                ) == 0
              "
            >
              {{ lang["no_time_slots"][language] }}
            </div>
          </div>

          <div
            v-for="timeSlot in $_.orderBy( $_.filter(timeSlots, function (timeSlot) {
              return timeSlot.date == selectedDate;
            }),timeslot => timeslot.start_time)"
            :key="timeSlot.date + timeSlot.start_time"
            :class="[
              '',
              selectedTimeSlot == `${timeSlot.date} ${timeSlot.start_time}`
                ? 'shadow-lg transition duration-500 hover:shadow-xl ' +
                  theme.body.selectedBackgroundColor +
                  ' ' +
                  theme.body.selectedTextColor
                : theme.body.backgroundColor + ' ' + theme.body.textColor,
              'w-full h-10 mt-2 rounded flex items-center justify-center rounded-large shadow-lg transition duration-500  hover:shadow-xl',
            ]"
            @click="
              selectedTimeSlot = `${timeSlot.date} ${timeSlot.start_time}`
            "
          >
            {{ timeSlot.start_time.substring(0, 5) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import SkeletonLoader from "../components/SkeletonLoader";
import moment from "moment";
export default {
  components: { SkeletonLoader },
  data() {
    return {
      lang: lang,
      loading: false,
      selectedDate: "",
      totalDaysVisible: 3,
      fullDates: [],
      loadMoreDaysVisible: true,
    };
  },
  computed: {
    ...mapGetters(["language", "theme", "menu"]),
    ...mapGetters("Cart", ["timeSlots", "selectedTimeSlot"]),
    selectedTimeSlot: {
      get() {
        return this.$store.getters["Cart/selectedTimeSlot"];
      },
      set(value) {
        this.$store.commit("Cart/updateSelectedTimeSlot", value);
      },
    },
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("Cart/GET_TIME_SLOTS")
      .then(() => {
        this.loading = false;
      })
      .catch((error) => {
        if (error.response.status == 404) {
          this.loading = false;
          this.$router.go(-3);
        }
      });

    for (let i = 0; i < this.menu.max_timesl_days; i++) {
      let date = { date: "", dayInText: "", fullDate: "" };
      date.dayInText = moment()
        .lang(this.language)
        .add(i, "days")
        .format("dddd");
      date.date = moment().lang(this.language).add(i, "days").format("Do MMM");
      date.fullDate = moment().add(i, "days").format().substring(0, 10);
      this.fullDates.push(date);
    }

    this.selectedDate = this.selectedTimeSlot.substring(0, 10);
  },
  updated() {
    //Calculation to know if the 'more days tab' needs to be open or not.
    if (
      this.selectedDate != "" &&
      moment(this.selectedDate).subtract(3, "days").calendar("do MMM") >=
        moment().calendar("do MMM")
    ) {
      this.showAllDates();
    }
  },
  methods: {
    changeDate(value) {
      this.selectedDate = value;
      this.selectedTimeSlot = "";
    },
    showAllDates() {
      if (
        this.enable_free_timeslots &&
        this.menu.timeslots_mode == "individual"
      ) {
        this.totalDaysVisible = 365;
      } else {
        this.totalDaysVisible = this.menu.max_timesl_days;
      }
      this.loadMoreDaysVisible = false;
    },
    showLessDates() {
      this.totalDaysVisible = 3;
      this.loadMoreDaysVisible = true;
    },
  },
};
</script>